import { ReactElement, useState } from "react";
import React from "react";
import { Link, matchPath, useLocation, useNavigate } from "react-router";
import "../../styles/style.scss";
import FormDirtyListener from "../formListener/FormDirtyListener";
import { LeaveDialog } from "../form/components/leavePage/LeavePageWarning";
import { eventEmitter } from "../../shared/event";
import { routes } from "../../shared/routes";

const hiddenRoutes = [
  "/applications/ApplicationBaseCurrent",
  "/applications/ApplicationBaseLegacy",
  "/provider/applications/ApplicationBaseCurrent",
  "/provider/applications/ApplicationBaseLegacy",
  "/assessments/ApplicationBaseCurrent",
  "/assessments/ApplicationBaseLegacy",
  "/myapplications/ApplicationBaseCurrent",
  "/myapplications/ApplicationBaseLegacy",
  "/finalised/ApplicationBaseCurrent",
  "/finalised/ApplicationBaseLegacy",
  "/applicationsLegacy/ApplicationBaseLegacy",
  "/assessmentsLegacy/ApplicationBaseLegacy",
  "/myapplicationsLegacy/ApplicationBaseLegacy",
  "/finalisedLegacy/ApplicationBaseLegacy",
];

export default function Breadcrumbs(): ReactElement | null {
  const location = useLocation();
  const [showDialog, setShowDialog] = useState(false);
  const [navigatePath, setNavigatePath] = useState("");
  const navigate = useNavigate();
  const [isDirty, setIsDirty] = useState(false);

  const pathname = location.pathname;
  const pathSegments = pathname.split("/").filter(Boolean);

  const handleBreadcrumbClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, path: string) => {
    if (isDirty) {
      e.preventDefault();
      setNavigatePath(path);
      setShowDialog(true);
      return;
    }
  };

  const handleLeavePage = () => {
    setShowDialog(false);
    eventEmitter.emit("IsDirtyForm", false);
    navigate(navigatePath);
  };

  const handleStay = () => {
    setShowDialog(false);
  };

  // Build full breadcrumb list from URL
  const breadcrumbs = [
    { label: "Home", path: "/" },
    ...pathSegments.map((segment, index, array) => {
      const path = "/" + array.slice(0, index + 1).join("/");

      return {
        label: segment.charAt(0).toUpperCase() + segment.slice(1),
        path,
      };
    }),
  ];

  // Check if a custom route matches current path
  const customRoute = routes.find((route) => matchPath({ path: route.path, end: true }, pathname));

  // If matched, replace ONLY last breadcrumb label
  if (customRoute && breadcrumbs.length > 1) {
    breadcrumbs[breadcrumbs.length - 1].label = customRoute.breadcrumb;
  }

  return (
    <>
      <FormDirtyListener onDirtyChange={setIsDirty} />
      <nav>
        <ul className="breadcrumb m-0">
          {breadcrumbs
            .filter((crumb) => !hiddenRoutes.includes(crumb.path))
            .map((crumb) => (
              <li className="breadcrumb-item" key={crumb.path}>
                <Link to={crumb.path} className="breadcrumb-link" onClick={(e) => handleBreadcrumbClick(e, crumb.path)}>
                  {crumb.label}
                </Link>
              </li>
            ))}
        </ul>
      </nav>
      {showDialog && LeaveDialog(showDialog, handleStay, handleLeavePage)}
    </>
  );
}
